export const snilsValidation = (snils, error) => {
    let result = false;
    snils = snils.replace(/[^\d]/g, '');
    if (typeof snils === 'number') {
        snils = snils.toString();
    } else if (typeof snils !== 'string') {
        snils = '';
    }
    // if (!snils.length) {
    //     error.code = 1;
    //     error.message = 'СНИЛС пуст';
    // } else if (/[^0-9]/.test(snils)) {
    //     error.code = 2;
    //     error.message = 'СНИЛС может состоять только из цифр';
    // } else
    if (snils.length !== 11) {
        error.code = 3;
        error.message = 'СНИЛС может состоять только из 11 цифр';
    } else {
        let sum = 0;
        for (let i = 0; i < 9; i++) {
            sum += parseInt(snils[i]) * (9 - i);
        }
        let checkDigit = 0;
        if (sum < 100) {
            checkDigit = sum;
        } else if (sum > 101) {
            checkDigit = parseInt(sum % 101);
            if (checkDigit === 100) {
                checkDigit = 0;
            }
        }
        if (checkDigit === parseInt(snils.slice(-2))) {
            result = true;
        } else {
            error.code = 4;
            error.message = 'Несуществующий СНИЛС';
        }
    }
    return result;
};

export const phoneValidator = (phone, error) => {
    let result = false;
    phone = phone.replace(/[^\d]/g, '');
    if (typeof phone === 'number') {
        phone = phone.toString();
    } else if (typeof phone !== 'string') {
        phone = '';
    }
    if (phone.length !== 11) {
        error.code = 3;
        error.message = 'Номер телефона должен состоять из 11 цифр';
    } else {
        result = true;
    }
    return result;
}

export const emailValidator = (email, error) => {
    let result = false;
    const regEmail = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    result = regEmail.test(String(email).toLowerCase());
    if (!result) {
        error.code = 1;
        error.message = 'Введите правильный email';
    }
    return result;
}
